const config = require("../config.js");
const UTILS = require("./utils.js");
module.exports = function (p7806, p7807) {
  var vP78053 = require("../141.js")(p7806);
  var vP78054 = require("../142.js")(p7806);
  var vLSLambert = "lambert";
  var v6572 = p7806.ShaderLib[vLSLambert].fragmentShader;
  v6572 = "\n\t\tuniform sampler2D texture1;\n\t\tvarying vec3 vertexColor;\n\t\tvarying vec3 vertexEmissive;\n\t\tvarying float vertexOpacity;\n\t\tvarying float vertexVisible;\n\t\tvarying float vertexTex;\n\t\tvarying vec2 vertexTexOff;\n\t\tvarying float vertexAlphaTest;\n\t" + v6572;
  v6572 = v6572.replace("vec4 diffuseColor = vec4( diffuse, opacity );", "\n\t\tif (vertexVisible == 0.0) discard;\n\t\tvec4 diffuseColor = vec4( vertexColor, vertexOpacity );\n\t");
  v6572 = v6572.replace(" = emissive;", " = vertexEmissive;");
  v6572 = v6572.replace("#include <map_fragment>", "\n\t\tif (vertexTex > 0.0) {\n\t\t\tvec4 texelColor = texture2D( texture1, vertexTexOff );\n\t\t\tdiffuseColor *= texelColor;\n\t\t}\n\t");
  v6572 = v6572.replace("#include <color_fragment>", "");
  v6572 = v6572.replace("#include <alphatest_fragment>", "if ( diffuseColor.a < vertexAlphaTest ) discard;");
  var v6573 = p7806.ShaderLib[vLSLambert].vertexShader;
  v6573 = "\n\t\tattribute vec3 iOffset;\n\t\tattribute vec3 iScale;\n\t\tattribute vec4 iRotation;\n\t\tattribute vec3 iColor;\n\t\tattribute vec3 iEmissive;\n\t\tattribute vec4 iTexOff;\n\t\tattribute float iTex;\n\t\tattribute float iOpacity;\n\t\tattribute float iVisible;\n\t\tattribute float iAlphaTest;\n\t\tvarying vec3 vertexColor;\n\t\tvarying vec3 vertexEmissive;\n\t\tvarying float vertexTex;\n\t\tvarying vec2 vertexTexOff;\n\t\tvarying float vertexVisible;\n\t\tvarying float vertexOpacity;\n\t\tvarying float vertexAlphaTest;\n\n\t\tvec3 applyTRS( vec3 position, vec3 translation, vec4 quaternion, vec3 scale ) {\n\t\t\tposition *= scale;\n\t\t\tposition += 2.0 * cross( quaternion.xyz, cross( quaternion.xyz, position ) + quaternion.w * position );\n\t\t\treturn position + translation;\n\t\t}\n\t" + v6573;
  v6573 = v6573.replace("#include <project_vertex>", "\n\t\t// COLOR:\n\t\tvertexColor = iColor;\n\t\tvertexEmissive = iEmissive;\n\t\tvertexOpacity = iOpacity;\n\t\tvertexAlphaTest = iAlphaTest;\n\n\t\t// TEXTURE ATLASS OFFSET:\n\t\tvertexTexOff = vec2(mix(iTexOff[0], iTexOff[1], uv.x), mix(iTexOff[2], iTexOff[3], uv.y));\n\n\t\t// TEXTURE SRC:\n\t\tvertexTex = iTex;\n\n\t\t// VISIBILITY:\n\t\tvertexVisible = iVisible;\n\n\t\t// POSITION:\n\t\tvec3 vPosition = applyTRS( transformed, iOffset, iRotation, iScale );\n\t\ttransformed = vPosition;\n\t\tvec4 mvPosition = modelViewMatrix * vec4( vPosition, 1.0 );\n\t\tgl_Position = projectionMatrix * modelViewMatrix * vec4( vPosition, 1.0 );\n\t");
  let v6574 = new p7806.BoxGeometry(1, 1, 1);
  v6574.translate(0, 0.5, 0);
  let v6575 = new p7806.PlaneGeometry(1, 1, 1, 1);
  class C243 extends p7806.Mesh {
    constructor(p7808, p7809, p7810) {
      super();
      this.name = "ShaderMesh";
      this.uniforms = p7806.UniformsUtils.clone(p7806.ShaderLib[vLSLambert].uniforms);
      this.uniforms.texture1 = {
        type: "t",
        value: C243.merger.texture
      };
      this.frustumCulled = false;
      this.material = new p7806.ShaderMaterial({
        fragmentShader: v6572,
        vertexShader: v6573,
        uniforms: this.uniforms,
        lights: true,
        dithering: true,
        side: p7806.DoubleSide,
        fog: true,
        shading: p7806.FlatShading,
        depthPacking: p7806.RGBADepthPacking,
        vertexColors: true,
        transparent: false
      });
      this.geometry = new p7806.InstancedBufferGeometry().copy(p7809 || v6574);
      this.geometry.instanceCount = p7810 || p7808.length;
      this.numInstances = this.geometry.instanceCount;
      this.iColors = new Float32Array(this.numInstances * 3);
      this.iEmissives = new Float32Array(this.numInstances * 3);
      this.iAlphaTests = new Float32Array(this.numInstances * 1);
      this.iOffsets = new Float32Array(this.numInstances * 3);
      this.iScales = new Float32Array(this.numInstances * 3);
      this.iRotations = new Float32Array(this.numInstances * 4);
      this.iOpacitys = new Float32Array(this.numInstances * 1);
      this.iVisibles = new Float32Array(this.numInstances * 1);
      this.iTexOffs = new Float32Array(this.numInstances * 4);
      this.iTexs = new Float32Array(this.numInstances * 1);
      this.geometry.setAttribute("iColor", new p7806.InstancedBufferAttribute(this.iColors, 3, false));
      this.geometry.setAttribute("iEmissive", new p7806.InstancedBufferAttribute(this.iEmissives, 3, false));
      this.geometry.setAttribute("iAlphaTest", new p7806.InstancedBufferAttribute(this.iAlphaTests, 1, false));
      this.geometry.setAttribute("iOffset", new p7806.InstancedBufferAttribute(this.iOffsets, 3, false));
      this.geometry.setAttribute("iScale", new p7806.InstancedBufferAttribute(this.iScales, 3, false));
      this.geometry.setAttribute("iRotation", new p7806.InstancedBufferAttribute(this.iRotations, 4, false));
      this.geometry.setAttribute("iOpacity", new p7806.InstancedBufferAttribute(this.iOpacitys, 1, false));
      this.geometry.setAttribute("iVisible", new p7806.InstancedBufferAttribute(this.iVisibles, 1, false));
      this.geometry.setAttribute("iTexOff", new p7806.InstancedBufferAttribute(this.iTexOffs, 4, false));
      this.geometry.setAttribute("iTex", new p7806.InstancedBufferAttribute(this.iTexs, 1, false));
      this.geometry.attributes.iVisible.setUsage(p7806.DynamicDrawUsage);
      this.objects = [];
      for (let vLN01043 = 0; vLN01043 < p7808.length; vLN01043++) {
        if (p7808[vLN01043].src) {
          C243.updateTextureOffsets(p7808[vLN01043]);
        }
        this.objects.push(new vP78054(vLN01043, {
          color: this.iColors,
          emissive: this.iEmissives,
          alphaTest: this.iAlphaTests,
          position: this.iOffsets,
          scale: this.iScales,
          rotation: this.iRotations,
          opacity: this.iOpacitys,
          visible: this.iVisibles,
          textureOffset: this.iTexOffs,
          texture: this.iTexs
        }, p7808[vLN01043]));
      }
      this.castShadow = true;
      this.receiveShadow = true;
      this.customDepthMaterial = v6577;
    }
    addObj(p7811) {
      var v6576 = this.objects.findIndex(p7812 => p7812.active == false);
      if (v6576 > -1) {
        this.objects[v6576] = new vP78054(v6576, {
          color: this.iColors,
          emissive: this.iEmissives,
          alphaTest: this.iAlphaTests,
          position: this.iOffsets,
          scale: this.iScales,
          rotation: this.iRotations,
          opacity: this.iOpacitys,
          visible: this.iVisibles,
          textureOffset: this.iTexOffs,
          texture: this.iTexs
        }, p7811);
      } else {
        v6576 = this.objects.length;
        this.objects.push(new vP78054(v6576, {
          color: this.iColors,
          emissive: this.iEmissives,
          alphaTest: this.iAlphaTests,
          position: this.iOffsets,
          scale: this.iScales,
          rotation: this.iRotations,
          opacity: this.iOpacitys,
          visible: this.iVisibles,
          textureOffset: this.iTexOffs,
          texture: this.iTexs
        }, p7811));
      }
      this.geoUpdate();
    }
    geoUpdate() {
      this.geometry.attributes.iColor.needsUpdate = true;
      this.geometry.attributes.iEmissive.needsUpdate = true;
      this.geometry.attributes.iAlphaTest.needsUpdate = true;
      this.geometry.attributes.iOffset.needsUpdate = true;
      this.geometry.attributes.iScale.needsUpdate = true;
      this.geometry.attributes.iRotation.needsUpdate = true;
      this.geometry.attributes.iOpacity.needsUpdate = true;
      this.geometry.attributes.iVisible.needsUpdate = true;
      this.geometry.attributes.iTexOff.needsUpdate = true;
      this.geometry.attributes.iTex.needsUpdate = true;
    }
    remObj(p7813) {
      this.objects.filter(p7814 => p7814.uid == p7813).forEach(p7815 => {
        p7815.dispose();
      });
      this.geometry.attributes.iVisible.needsUpdate = true;
    }
    updateTextures() {
      this.objects.filter(p7816 => p7816.data.src).forEach(p7817 => {
        C243.updateTextureOffsets(p7817.data);
        p7817.updateTexture();
      });
      this.geometry.attributes.iTexOff.needsUpdate = true;
      this.geometry.attributes.iTex.needsUpdate = true;
    }
    clear() {
      for (let vLN01044 = 0; vLN01044 < this.objects.length; vLN01044++) {
        this.objects[vLN01044].dispose();
      }
      this.geoUpdate();
    }
    clean() {
      this.geometry.dispose();
    }
    dispose() {
      this.geometry.dispose();
      this.material.dispose();
    }
  }
  var v6577 = new p7806.MeshDepthMaterial({
    depthPacking: p7806.RGBADepthPacking,
    alphaTest: 0.5,
    blending: p7806.NoBlending
  });
  v6577.onBeforeCompile = p7818 => {
    p7818.vertexShader = "\n\t\t\t#define DEPTH_PACKING 3201\n\t\t\tattribute vec3 iOffset;\n\t\t\tattribute vec3 iScale;\n\t\t\tattribute vec4 iRotation;\n\t\t\tattribute float iVisible;\n\t\t\tvarying float vertexVisible;\n\n\t\t\tvec3 applyTRS( vec3 position, vec3 translation, vec4 quaternion, vec3 scale ) {\n\t\t\t\tposition *= scale;\n\t\t\t\tposition += 2.0 * cross( quaternion.xyz, cross( quaternion.xyz, position ) + quaternion.w * position );\n\t\t\t\treturn position + translation;\n\t\t\t}\n\t\t" + p7818.vertexShader;
    p7818.vertexShader = p7818.vertexShader.replace("#include <project_vertex>", "\n\t\t\tvertexVisible = iVisible;\n\t\t\ttransformed = applyTRS( transformed, iOffset, iRotation, iScale );\n\t\t\tvec4 mvPosition = vec4( transformed, 1.0 );\n\t\t\tmvPosition = modelMatrix * mvPosition;\n\t\t\tmvPosition = modelViewMatrix * mvPosition;\n\t\t\tgl_Position = projectionMatrix * mvPosition;\n\t\t");
    p7818.fragmentShader = "\n\t\t\t#define DEPTH_PACKING 3201\n\t\t\tvarying float vertexVisible;\n\t\t" + p7818.fragmentShader;
    p7818.fragmentShader = p7818.fragmentShader.replace("#include <clipping_planes_fragment>", "\n\t\t\tif (vertexVisible == 0.0) discard;\n\t\t\t#include <clipping_planes_fragment>\n\t\t");
  };
  C243.enabled = false;
  C243.supported = true;
  C243.finalized = false;
  C243.merger = {
    texture: null,
    ranges: {}
  };
  C243.CUBES = {
    instances: [],
    mesh: null
  };
  C243.PLANES = {
    instances: [],
    mesh: null
  };
  C243.BUILDS = null;
  C243.MODELS = {};
  C243.addBuild = function (p7819, p7820, p7821, p7822, p7823, p7824, p7825) {
    if (C243.supported) {
      p7825.src = p7825.src || "";
      if (p7825.src.includes("default")) {
        p7825.src = null;
      }
      p7825.src = p7825.src || null;
      if (p7825.model) {
        p7825.colr = "#ffffff";
        p7820 += p7823 / 2;
        var v6578 = false;
        if (C243.MODELS[p7825.src]) {
          v6578 = C243.MODELS[p7825.src].pending;
        } else {
          v6578 = true;
          C243.MODELS[p7825.src] = {
            pending: true,
            pendingObjs: [],
            mesh: null
          };
          p7807.loadGeo(p7825, function (p7826, p7827) {
            C243.MODELS[p7826.src].mesh = new C243([], p7827, 2500);
            p7807.add(C243.MODELS[p7826.src].mesh);
            for (var vLN01045 = 0; vLN01045 < C243.MODELS[p7826.src].pendingObjs.length; vLN01045++) {
              C243.MODELS[p7826.src].mesh.addObj(C243.MODELS[p7826.src].pendingObjs[vLN01045]);
            }
            C243.MODELS[p7826.src].pending = false;
            C243.MODELS[p7826.src].pendingObjs.length = 0;
          });
        }
      } else if (!C243.BUILDS) {
        C243.BUILDS = new C243([], v6574, 2500);
        p7807.add(C243.BUILDS);
      }
      C243.updateTextureOffsets(p7825);
      var vO195 = {
        type: p7825.type || 0,
        x: p7819,
        y: p7820,
        z: p7821,
        uid: p7825.uid,
        src: p7825.src,
        color: p7825.colr,
        emissive: p7825.emissive,
        w: p7825.model ? 1 : p7822,
        h: p7825.model ? 1 : p7823,
        l: p7825.model ? 1 : p7824,
        opacity: UTILS.limitMM(p7825.opacity, 0, 1),
        dir: p7825.dir,
        xR: p7825.xR,
        yR: p7825.yR,
        zR: p7825.zR,
        texOff: p7825.texOff,
        tex: p7825.tex
      };
      if (vO195.type == 2) {
        var v6579 = vO195.dir != 0 && vO195.dir != Math.PI;
        var v6580 = Math.sqrt(p7823 * p7823 + p7824 * p7824);
        if (p7825.model) {
          if (v6579) {
            vO195.xR = -vO195.dir;
          } else {
            vO195.zR = vO195.dir / 2;
          }
        } else {
          vO195.h = 2;
          vO195.y = p7820 + p7823 / 2 - 1;
          vO195.w = v6579 ? p7822 : v6580;
          vO195.l = v6579 ? v6580 : p7822;
          vO195[v6579 ? "yR" : "zR"] = Math.asin(p7823 / v6580) - Math.PI / 2;
          if (vO195.dir <= 0) {
            vO195[v6579 ? "yR" : "zR"] *= -1;
          }
        }
      }
      if (p7825.model) {
        if (v6578) {
          C243.MODELS[p7825.src].pendingObjs.push(vO195);
        } else {
          C243.MODELS[p7825.src].mesh.addObj(vO195);
        }
      } else {
        C243.BUILDS.addObj(vO195);
      }
    }
  };
  C243.removeBuild = function (p7828, p7829) {
    if (p7829 && p7829.model && C243.MODELS[p7829.src] && C243.MODELS[p7829.src].mesh) {
      C243.MODELS[p7829.src].mesh.remObj(p7828);
      return;
    } else {
      if (C243.BUILDS) {
        C243.BUILDS.remObj(p7828);
      }
      return;
    }
  };
  C243.addPlane = function (p7830, p7831, p7832, p7833, p7834, p7835, p7836, p7837, p7838) {
    p7835.src = p7835.src || "";
    if (p7835.src.includes("default")) {
      p7835.src = null;
    }
    p7835.src = p7835.src || null;
    C243.PLANES.instances.push({
      type: 1,
      x: p7830,
      y: p7831,
      z: p7832,
      src: p7835.src,
      color: p7835.colr,
      emissive: p7835.emissive,
      w: p7833,
      l: p7834,
      h: 1,
      opacity: UTILS.limitMM(p7835.opacity, 0, 1),
      xR: p7836,
      yR: p7837,
      zR: p7838,
      texOff: [0, 0, 0, 0],
      tex: 0
    });
    return C243.createProxyObj(1, C243.PLANES.instances.length - 1);
  };
  C243.addRamp = function (p7839, p7840, p7841, p7842, p7843, p7844, p7845, p7846, p7847) {
    p7846.src = p7846.src || "";
    if (p7846.src.includes("default")) {
      p7846.src = null;
    }
    p7846.src = p7846.src || null;
    var v6581 = Math.sqrt(p7843 * p7843 + p7844 * p7844);
    C243.PLANES.instances.push({
      type: 1,
      x: p7839,
      y: p7840 + p7843 / 2,
      z: p7841,
      src: p7846.src,
      color: p7846.colr,
      emissive: p7846.emissive,
      w: p7842,
      l: v6581,
      h: 2,
      opacity: UTILS.limitMM(p7846.opacity, 0, 1),
      xR: -(Math.PI / 2) - p7845,
      yR: Math.asin(p7843 / v6581),
      zR: p7847 || 0,
      ramp: true,
      texOff: [0, 0, 0, 0],
      tex: 0
    });
    return C243.createProxyObj(1, C243.PLANES.instances.length - 1);
  };
  C243.addCube = function (p7848, p7849, p7850, p7851, p7852, p7853, p7854) {
    p7854.src = p7854.src || "";
    if (p7854.src.includes("default")) {
      p7854.src = null;
    }
    p7854.src = p7854.src || null;
    C243.CUBES.instances.push({
      type: 0,
      x: p7848,
      y: p7849,
      z: p7850,
      sid: p7854.sid,
      src: p7854.src,
      color: p7854.colr,
      emissive: p7854.emissive,
      w: p7851,
      h: p7852,
      l: p7853,
      opacity: UTILS.limitMM(p7854.opacity, 0, 1),
      xR: p7854.xR,
      yR: p7854.yR,
      zR: p7854.zR,
      texOff: [0, 0, 0, 0],
      tex: 0
    });
    return C243.createProxyObj(0, C243.CUBES.instances.length - 1);
  };
  C243.createProxyObj = function (p7855, p7856) {
    var vO196 = {
      type: p7855 || 0,
      id: p7856
    };
    Object.defineProperty(vO196, "visible", {
      get() {
        if (this.type == 0) {
          return !!C243.CUBES.mesh.objects[parseInt(this.id)].visible;
        } else {
          return this.type == 1 && !!C243.PLANES.mesh.objects[parseInt(this.id)].visible;
        }
      },
      set(p7857) {
        if (this.type == 0) {
          C243.CUBES.mesh.objects[parseInt(this.id)].visibility(p7857);
          C243.CUBES.mesh.geometry.attributes.iVisible.needsUpdate = true;
        } else if (this.type == 1) {
          C243.PLANES.mesh.objects[parseInt(this.id)].visibility(p7857);
          C243.PLANES.mesh.geometry.attributes.iVisible.needsUpdate = true;
        }
        return !!p7857;
      }
    });
    return vO196;
  };
  C243.reset = function () {
    if (C243.CUBES.mesh) {
      p7807.scene.remove(C243.CUBES.mesh);
    }
    C243.CUBES.mesh = null;
    C243.CUBES.instances.length = 0;
    if (C243.PLANES.mesh) {
      p7807.scene.remove(C243.PLANES.mesh);
    }
    C243.PLANES.mesh = null;
    C243.PLANES.instances.length = 0;
    if (C243.BUILDS) {
      p7807.scene.remove(C243.BUILDS);
    }
    C243.BUILDS = null;
  };
  C243.finalize = function () {
    C243.finalized = true;
    if (C243.CUBES.instances.length) {
      C243.CUBES.mesh = new C243(C243.CUBES.instances, v6574);
      C243.CUBES.instances.length = 0;
      p7807.add(C243.CUBES.mesh);
    }
    if (C243.PLANES.instances.length) {
      C243.PLANES.mesh = new C243(C243.PLANES.instances, v6575);
      C243.PLANES.instances.length = 0;
      p7807.add(C243.PLANES.mesh);
    }
  };
  C243.updateTextureMap = function (p7858) {
    var v6582 = new vP78053(p7858);
    C243.merger.texture = v6582.mergedTexture;
    C243.merger.ranges = v6582.ranges;
    if (C243.finalized) {
      if (C243.CUBES.mesh) {
        C243.CUBES.mesh.material.uniforms.texture1.value = C243.merger.texture;
        C243.CUBES.mesh.material.uniforms.texture1.needsUpdate = true;
        C243.CUBES.mesh.updateTextures();
      }
      if (C243.PLANES.mesh) {
        C243.PLANES.mesh.material.uniforms.texture1.value = C243.merger.texture;
        C243.PLANES.mesh.material.uniforms.texture1.needsUpdate = true;
        C243.PLANES.mesh.updateTextures();
      }
    }
    if (C243.BUILDS) {
      C243.BUILDS.material.uniforms.texture1.value = C243.merger.texture;
      C243.BUILDS.material.uniforms.texture1.needsUpdate = true;
      C243.BUILDS.updateTextures();
    }
    if (C243.MODELS) {
      for (var v6583 in C243.MODELS) {
        if (C243.MODELS[v6583].mesh) {
          C243.MODELS[v6583].mesh.material.uniforms.texture1.value = C243.merger.texture;
          C243.MODELS[v6583].mesh.material.uniforms.texture1.needsUpdate = true;
          C243.MODELS[v6583].mesh.updateTextures();
        }
      }
    }
  };
  C243.updateTextureOffsets = function (p7859) {
    if (C243.merger.ranges[p7859.src]) {
      p7859.texOff = [...Object.values(C243.merger.ranges[p7859.src])];
      var v6584 = 0.5 / p7859.texOff[4];
      p7859.texOff[0] += v6584;
      p7859.texOff[1] -= v6584;
      p7859.texOff[2] -= v6584;
      p7859.texOff[3] += v6584;
      p7859.texOff.length = 4;
      p7859.tex = 1;
    } else {
      p7859.texOff = [0, 0, 0, 0];
      p7859.tex = 0;
    }
  };
  return C243;
};